import React, { FunctionComponent } from 'react';
import InlineElement from './Inline';
import DefaultElement from './Default';

export const CalculatorElement: FunctionComponent<{
  inlineContent?: JSX.Element | string;
  isInline?: boolean;
  onClick: () => void;
}> = ({ inlineContent, isInline, onClick }) =>
  isInline ? (
    <InlineElement content={inlineContent} onClick={onClick} />
  ) : (
    <DefaultElement onClick={onClick} />
  );

export default CalculatorElement;
